import CoreServices from './coreServices'
import axios from 'axios'

class ModelServices extends CoreServices {
  async changeAvailabelStatus(params) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/models/available-status`, params, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async moderatorApprove(params) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/moderator-approve`, params, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async moderatorReject(params) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/users/moderator-reject`, params, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async getActiveReward(queries) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/active-reward`, {
        params: queries,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getRankings(queries) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/users/rankings`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        params: queries
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async uploadAddressDocument(params) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/models/address-document`, params, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async uploadWalletVerifyDocument(params) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/models/wallet-verify`, params, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getWithdrawFee(params) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/models/withdraw-fee`, {
        params: params,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getPayout() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/models/payout`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }
  
  async savePayoutAddress(params) {
    try {
      let response = await axios.put(`${this.apiEnpointV1}/models/payout`, params, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async payoutReview() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/models/payout-review`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async saveWalletAddress(params) {
    try {
      let response = await axios.put(`${this.apiEnpointV1}/models/wallet-address`, params, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async saveSignature(params) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/models/signature`, params, {
        headers: {
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }


}

export default new ModelServices(null)
